export default __webpack_public_path__ + "static/media/Mobile-02.add3fa14.jpg";